import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import X_Icon_DarkBlue from '../../assets/images/svg/X-Icon-DarkBlue.svg';
import { useDispatch, useSelector } from 'react-redux';
import { product } from "./product/productSlice";
import { addtoCartProduct } from "./product/productLogic";
import LocalizedLanguage from "../../settings/LocalizedLanguage";
import { isAutoFocus } from "../../settings/AndroidIOSConnect";
const CustomFee = (props) => {
    const refTxtAreaFee = useRef();
    const refTxtAreaDiscount = useRef();
    const [feeAmount, setFeeAmount] = useState(0);
    const [add_title, setAdd_title] = useState("");     
    const [isRadioBtnActive, setisRadioBtnActive] = useState(false)
    const dispatch = useDispatch();

    const closePopup = () => {
        setAdd_title("");
        setFeeAmount(0)    
        props.toggleCustomFeeBtn();

    }
   

    useEffect(() => {
        setTimeout(() => {
            if (props.isSelectDiscountBtn == false) {
                if (refTxtAreaFee) {
                    setAdd_title("");
                    if (isAutoFocus() == true)
                    refTxtAreaFee && refTxtAreaFee.current && refTxtAreaFee.current.focus();
                }
            }
            else {
                if (refTxtAreaDiscount) {               
                    if (isAutoFocus() == true)
                    refTxtAreaDiscount && refTxtAreaDiscount.current && refTxtAreaDiscount.current.focus();
                }
            }
        }, 100);

    }, [props.isSelectDiscountBtn]);



    const clearDiscount = () => {
        var ListItem = localStorage.getItem("CARD_PRODUCT_LIST") ? JSON.parse(localStorage.getItem("CARD_PRODUCT_LIST")) : [];
        // ListItem && ListItem.map((item, index) => {
        //     item["after_discount"] = 0;//item.after_discount - item.cart_discount_amount;
        //     item["cart_after_discount"] = 0;
        //     item["cart_discount_amount"] = 0;
        // });
       
        localStorage.removeItem("CART")
        addtoCartProduct(ListItem);
        dispatch(product());
    }
    const FeeAmount = (val) => {
        setFeeAmount(val);
    }
    const AddTitle = (val) => {
        setAdd_title(val);
    }
    const AddFee = () => {
        //const { feeAmount, add_title ,isfeeTaxable} = this.state;
        //const { dispatch } = this.props;
        var cartlist = localStorage.getItem("CARD_PRODUCT_LIST") ? JSON.parse(localStorage.getItem("CARD_PRODUCT_LIST")) : []
        cartlist = cartlist == null ? [] : cartlist;
        var new_title = add_title !== '' ? add_title : LocalizedLanguage.customFee;
        var title = new_title;
        var new_array = [];
        var i = 0;
        if (cartlist.length > 0) {
            cartlist.map(item => {
                if (typeof item.product_id == 'undefined') {
                    if (item.Price !== null) {
                        new_array.push(item)
                    }
                }
            })
        }

        if (feeAmount != 0) {
            if (new_array.length > 0) {
                var withNoDigits = new_array.map(item => {
                    var remveNum = item.Title.replace(/[0-9]/g, '')
                    return remveNum;
                });
                withNoDigits.length > 0 && withNoDigits.map((item, index) => {
                    if (item == title) {
                        var incr = index + 1
                        new_title = item + incr;
                    } else {
                        new_title = new_title
                    }
                })
            }
            var data = {
                Title: new_title,
                Price: parseFloat(feeAmount),
                old_price: isRadioBtnActive == true && parseFloat(feeAmount),
                isTaxable: isRadioBtnActive,
                TaxStatus: isRadioBtnActive == true ? "taxable" : "none",
                TaxClass: '',
                quantity: 1
            }

            cartlist.push(data)
            addtoCartProduct(cartlist);
            dispatch(product());
            var list = localStorage.getItem('CHECKLIST') ? JSON.parse(localStorage.getItem('CHECKLIST')) : null;
            if (list != null) {
                var subTotal = parseFloat(list.subTotal + data.Price).toFixed(2);
                //var tax= parseFloat(list.tax +  data.Price).toFixed(2);
                const CheckoutList = {
                    ListItem: cartlist,
                    customerDetail: list.customerDetail,
                    totalPrice: parseFloat((subTotal) + parseFloat(list.tax)),
                    discountCalculated: list.discountCalculated,
                    tax: list.tax,
                    subTotal: subTotal,
                    TaxId: list.TaxId,
                    order_id: list.order_id !== 0 ? list.order_id : 0,
                    showTaxStaus: list.showTaxStaus,
                    _wc_points_redeemed: list._wc_points_redeemed,
                    _wc_amount_redeemed: list._wc_amount_redeemed,
                    _wc_points_logged_redemption: list._wc_points_logged_redemption,

                }
                localStorage.setItem('CHECKLIST', JSON.stringify(CheckoutList))
                // location.reload();
            }
            setFeeAmount(0);
            setAdd_title("");
            props.toggleCustomFeeBtn();
        }
    }
    const outerClick = (e) => {
        if (e && e.target && e.target.className && e.target.className === "subwindow-wrapper") {
            props.toggleCustomFeeBtn();
        }
    }
    const hundleCheckbox = (e) => {
        setisRadioBtnActive(!isRadioBtnActive)
    }
    var CurrencySymbol = localStorage.getItem('currecySymbole') ? localStorage.getItem('currecySymbole'):"$";
    return (
        <div className={props.isCustomFeeBtn === true ? "subwindow-wrapper" : "subwindow-wrapper hidden"} onClick={(e) => outerClick(e)}>
            <div className={props.isCustomFeeBtn === true ?  "subwindow custom-fee current" : "subwindow cart-discount custom-fee"}> 
           
                <div className="subwindow-header">
                    <p>{LocalizedLanguage.customFee}</p>
                    <button className="close-subwindow" onClick={() => closePopup()}>
                        <img src={X_Icon_DarkBlue} alt="" />
                    </button>
                </div>
                <div className="subwindow-body">
                    <div className="auto-margin-top"></div>
                  {/*   <p className="style1">{LocalizedLanguage.Selectanoption}:</p>
                    <div className="toggle-container">
                        <label >
                            <input type="radio" id="customFeeRadio" name="customFeeDiscount" defaultChecked={props.isSelectDiscountBtn == false ? true : false} />
                            <div className="custom-radio" onClick={() => props.isSelectDiscountBtn == true ? props.toggleSelectDiscountBtn() : null}>
                                <p>{LocalizedLanguage.customFee}</p>
                            </div>
                        </label>
                        <label >
                            <input type="radio" id="discountRadio" name="customFeeDiscount" defaultChecked={props.isSelectDiscountBtn == true ? true : false} />
                            <div className="custom-radio" onClick={() => props.isSelectDiscountBtn == false ? props.toggleSelectDiscountBtn() : null}>
                                <p>{LocalizedLanguage.discount}</p>
                            </div>
                        </label>
                    </div>
                    {props.isSelectDiscountBtn == false ?
                        */}
                        <div id="customFeeDiv">
                            <label htmlFor="customFeeLabel">{LocalizedLanguage.customFeelabel}</label>
                            <input ref={refTxtAreaFee} type="text" id="customFeeLabel" placeholder={LocalizedLanguage.placeholdercustomfee} value={add_title} onChange={(e) => AddTitle(e.target.value)} />
                            <input type="number" id="customFeeAmount" placeholder="0.00" value={feeAmount} onChange={(e) => FeeAmount(e.target.value)} />
                            <p>{LocalizedLanguage.appliesfeetocart}</p>
                            <label className="custom-toggle-wrapper">
                                <p>{ LocalizedLanguage.applyTaxesToCustomFee}</p>
                                <input type="checkbox"
                                    //  id="isCustomFeeTaxed" 
                                    value={true}
                                    checked={isRadioBtnActive}
                                    //  checked={this.state.site === result.SITE_NAME}
                                    onChange={hundleCheckbox} />
                                <div className="custom-toggle"></div>
                            </label>
                            <button onClick={() => AddFee()}>{ LocalizedLanguage.applyToCart}</button>
                           
                        </div>
                    <div className="auto-margin-bottom"></div>
                </div>
            </div>

        </div>




    )
}

export default CustomFee 